package us.laantech.common.dto.company

import kotlinx.serialization.Serializable
import us.laantech.common.dto.EmployeeDTO
import us.laantech.common.dto.UnitedStatesPostalAddress

@Serializable
data class CompanyBranch(
    val uuid: String?,
    val parentCompanyUuid: String?,
    val branchName: String? = null,
    val address: UnitedStatesPostalAddress? = null,
    val departments: List<Department> = listOf(),
    val posAds: List<PosAd> = listOf(),
    val cardTransactionRate5dp: Long? = null,

    // Managerial Employees, can login and access branch data
    val managers: List<EmployeeDTO>? = listOf(),
)

@Serializable
data class Department(
    val departmentUUID: String,
    val departmentName: String,
    val ageLimit: Int? = null,
)

@Serializable
enum class AdTransition {
    NONE,
    FADE,
    SLIDE,
}

@Serializable
data class PosAd(
    val sequence: Long?,
    val filename: String?,
    val presignedUrl: String? = null,
    val transition: AdTransition? = AdTransition.NONE,
    val mute: Boolean? = true,
    val durationSeconds: Long? = 15L,
)